import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { RouterModule } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RedirectionDialogModule } from 'src/app/components/redirection-dialog/redirection-dialog.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { InfraUpgradeComponent } from './infra-upgrade.component';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import {TableModule} from 'src/app/table/table.module';
import { CommonTableModule } from 'src/app/components/table/table.module';
import { EnvironmentTableModule } from '../environment-details/environment-table/environment-table.module';

@NgModule({
  declarations: [
    InfraUpgradeComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    PipesModule,
    IconsModule,
    RouterModule,
    MatMenuModule,
    MatDividerModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    RedirectionDialogModule,
    MatProgressBarModule,
    NgxSkeletonLoaderModule,
    MatSelectModule,
    MatIconModule,
    MatDialogModule,
    TableModule,
    CommonTableModule,
    EnvironmentTableModule
  ],
  exports: [
    InfraUpgradeComponent
  ]
})
export class InfraUpgradeModule { }
